import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Button         from '@material-ui/core/Button';
import Dialog         from '@material-ui/core/Dialog';
import DialogActions  from '@material-ui/core/DialogActions';
import DialogContent  from '@material-ui/core/DialogContent';
import DialogTitle    from '@material-ui/core/DialogContent';
import MenuItem       from '@material-ui/core/MenuItem';
import TextField      from '@material-ui/core/TextField';

const style = {
  newTickets: makeStyles((theme) => ({
    dialogContent: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
    },
  })),
};

export default function NewTickets(props) {
  const classes = style.newTickets();

  const { ticketOptions } = props.context.getStates();

  return (
    <Dialog open={props.newTickets[0] > -1}>
      <DialogTitle>{'새 티켓 추가'}</DialogTitle>

      <DialogContent className={classes.dialogContent}>
        {ticketOptions.length > 0 && props.newTickets[0] > -1 && (
          <TextField select value={props.newTickets[0]} label={'티켓'}
            onChange={(event) => { props.setNewTickets([event.target.value, props.newTickets[1]]); }}
            style={{flexGrow: 1000}}
          >
            {ticketOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        )}

        <TextField type="number" label="수량"
          InputProps={{ inputProps: {min: 0} }}
          onChange={(event) => { props.setNewTickets([props.newTickets[0], parseInt(event.target.value)]); }}
          value={props.newTickets[1]}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={(event) => {
          props.setNewTickets([-1, 0]);
        }}>
          {'취소'}
        </Button>
        <Button color="primary" onClick={(event) => { props.insertTickets(); }}>
          {'확인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
